import { useEffect, useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import MissionBulgaria from './components/MissionBulgaria';
import Experience from './components/Experience';
import Testimonials from './components/Testimonials';
import ClientsMap from './components/ClientsMap';
import Contact from './components/Contact';
import Navigation from './components/Navigation';
import CandlestickAnimation from './components/CandlestickAnimation';
import { LangProvider } from '../../i18n/LangContext';

export default function HomePage() {
  const [activeSection, setActiveSection] = useState('hero');

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['hero', 'about', 'mission', 'experience', 'testimonials', 'clients', 'contact'];
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <LangProvider>
      <div className="relative bg-[#0a0e1a] text-white overflow-hidden">
        <CandlestickAnimation />
        <Navigation activeSection={activeSection} />
        <Hero />
        <About />
        <MissionBulgaria />
        <Experience />
        <Testimonials />
        <ClientsMap />
        <Contact />
      </div>
    </LangProvider>
  );
}
